<template>
  <div class="attachment-list">
    <span v-if="title" class="attachment-list__header">{{ title }}</span>
    <div v-if="attachments.length">
      <div v-for="file in attachments" :key="file.fileId">
        <div v-if="file.createdBy && file.lastModifiedDate" class="attachment-list__info">           
          <icon class-name="attachment-list__info--icon" name="user-circle" />
          <span>{{ file.createdBy }} {{ getFormattedDate(file.lastModifiedDate) }}</span>
        </div>
        <div class="attachment-list__item">
          <div class="attachment-list__item__detail">
            <attachment-item :file="file" />
            <div class="attachment-list__item__detail__info">
              <span class="attachment-list__item__detail__info--name">{{ file.fileName }}</span>
              <span v-if="file.size" class="attachment-list__item__detail__info--size">Size: {{ file.size }}</span>
            </div>
          </div>
          <div class="attachment-list__item__actions">
            <a v-if="hasDownload" class="attachment-list__item__actions--download" @click.prevent="downloadAttachmentClick(file)">
              <span class="mi-24px mi-tray-arrow-down"></span>
            </a>
            <span v-if="hasDelete || file.isDeletable" class="mi-24px mi-trash attachment-list__item__actions--delete" @click.prevent="removeAttachmentClick(file)"></span>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <span class="attachment-list__not-found">No attachments found</span>
    </div>
  </div>
</template>

<script>
// Components
import AttachmentItem from "./AttachmentItem.vue";
import Icon from "../Icon/Icon.vue";

//utils
import { format } from "date-fns";

export default {
  name: "AttachmentList",
  components: {
    AttachmentItem,
    Icon
  },
  props: {
    attachments: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      default: ""
    },
    hasDelete: {
        type: Boolean,
        required: true
    },
    hasDownload: {
        type: Boolean,
        required: true
    }
  },
  methods: {
    getFileSize(file) {
      const { size } = file;
      return size ? `${Math.round(size / 1000)} kb` : "";
    },
    downloadAttachmentClick(file) {
        this.$emit('downloadAttachment', file);
    },
    removeAttachmentClick(file) {
        this.$emit('removeAttachment', file);
    },
    getFormattedDate(value) {
        try {
          return value ? format(new Date(value), "dd-MMM-yyyy hh:mm a") : "N/A";
        } catch (err) {
          return value;
        }
    }
  },
};
</script>

<style lang="scss" scoped>
  .attachment-list {
    &__header {
      font-family: "Maersk Text Bold";
      color: var(--Blue-900-Darkest);
      display: block;
      margin-bottom: 1.5rem;
    }
    &__info {
      display: flex;
        align-items: center;
        font-size: 14px;
        margin-bottom: 6px;
        i {
            margin-right: 4px;
        }
    }
    &__item {
      padding: 1rem;
      background: var(--Gray-100);
      display: flex;
      justify-content: space-between;
      align-items: center;
      max-width: 36rem;
      margin-bottom: 1.5rem;
        &__detail{
          display: flex;
          align-items: center;
          &__info {
            display: flex;
            flex-direction: column;
            margin-left: 1rem;
            &--name {
             font-family: "Maersk Text Bold";
            }
            &--size {
             color: var(--Gray-700);
            }
          }
        }
        &__actions {
            display: flex;
            justify-content: space-between;
            span {
                cursor: pointer;
                color: var(--Blue-900-Darkest);
            }
            &--delete {
                margin-left: 1rem;
            }
        }
      }
      &__not-found {
        display: block;
        margin: 1rem;
      }
  }
</style>